import IOSInstall from "../../../../contents/docs/integrate/_snippets/install-ios.mdx";
import IOSIdentify from "../../../../contents/docs/libraries/ios/_snippets/identify.mdx";
import IOSSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-ios.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import IOSFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-ios.mdx";
import * as React from 'react';
export default {
  IOSInstall,
  IOSIdentify,
  IOSSendEvents,
  FeatureFlagsLibsIntro,
  IOSFeatureFlagsCode,
  React
};